module.exports = __webpack_public_path__ + "img/knowledgeH5.d378c269.png";